import { formatCurrency } from '@getaccept/lib-shared/src/helpers/currency';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { Currency } from '@getaccept/lib-shared/src/types/Currency';
import type { Ref } from '@vue/composition-api';
import { computed } from '@vue/composition-api';
import type { DocumentStatsType } from '../../api/types/document-stats-type';
import { useDocumentStats } from './document-stats.composable';

export const useLoadDocumentStats = (
  documentStatsType: DocumentStatsType,
  showAll: Ref<boolean>,
  currency?: Ref<Currency>
) => {
  const { data, isLoading, isSuccess, isError } = useDocumentStats(showAll, documentStatsType);

  const documentCount = computed(() => data.value?.count ?? 0);
  const documentValue = computed(() => data.value?.value ?? 0);

  const title = computed(() => (documentCount.value === 1 ? t('Deal') : t('Deals')));
  const formattedValue = computed(() =>
    currency ? formatCurrency(documentValue.value, currency.value) : 0
  );

  return {
    isLoading,
    isSuccess,
    isError,
    documentCount,
    documentValue,
    formattedValue,
    title,
    data,
  };
};
